export const initialPayments = [
  {
    id: "PAY-2026-901",
    type: "Customer Receipt",
    referenceId: "SO-2026-502",
    referenceNumber: "SO/2026/08/502",
    partyName: "Annapurna Caterers & Wedding Kitchens",
    amount: 34571,
    paymentMethod: "Cheque (HDFC #44901)",
    date: "2026-08-06",
    status: "Completed",
    notes: "Full payment against invoice"
  },
  {
    id: "PAY-2026-902",
    type: "Customer Receipt",
    referenceId: "SO-2026-503",
    referenceNumber: "POS-2026-8801",
    partyName: "Walk-in Retail Counter Shopper",
    amount: 768,
    paymentMethod: "UPI",
    date: "2026-08-08",
    status: "Completed",
    notes: "Instant POS settlement"
  },
  {
    id: "PAY-2026-903",
    type: "Supplier Payment",
    referenceId: "SUP-006",
    referenceNumber: "PO/2026/07/105",
    partyName: "Amul Anand Dairy Depot (Bhiwandi Cold Chain)",
    amount: 42400,
    paymentMethod: "RTGS / NEFT",
    date: "2026-07-28",
    status: "Completed",
    notes: "Settled against Amul invoice"
  },
  {
    id: "PAY-2026-904",
    type: "Supplier Payment",
    referenceId: "SUP-001",
    referenceNumber: "PO/2026/08/108",
    partyName: "Hindustan Unilever Distributor (West Mumbai)",
    amount: 50000,
    paymentMethod: "Bank Transfer",
    date: "2026-08-05",
    status: "Completed",
    notes: "Partial payment for detergent lot"
  }
];

export const initialExpenses = [
  {
    id: "EXP-2026-301",
    category: "Warehouse Rent",
    amount: 85000,
    date: "2026-08-01",
    paidTo: "Rajlaxmi Logistics Complex, Bhiwandi",
    paymentMethod: "Bank NEFT",
    notes: "Monthly rent for Bhiwandi Hub (15,000 sq ft)",
    approvedBy: "Owner"
  },
  {
    id: "EXP-2026-302",
    category: "Warehouse Rent",
    amount: 45000,
    date: "2026-08-01",
    paidTo: "Bharat Coal Compound, Kurla",
    paymentMethod: "Bank NEFT",
    notes: "Monthly lease for Kurla Depot",
    approvedBy: "Owner"
  },
  {
    id: "EXP-2026-303",
    category: "Transportation & Freight",
    amount: 14500,
    date: "2026-08-03",
    paidTo: "Balaji Roadways & Tempo Union",
    paymentMethod: "UPI",
    notes: "Inter-warehouse stock shuttle (Bhiwandi -> Dadar & Kurla)",
    approvedBy: "Manager"
  },
  {
    id: "EXP-2026-304",
    category: "Electricity & Utilities",
    amount: 18200,
    date: "2026-08-04",
    paidTo: "MSEDCL & Adani Electricity",
    paymentMethod: "Auto Debit",
    notes: "Power bill for cold storage and warehouse LED lighting",
    approvedBy: "Finance"
  },
  {
    id: "EXP-2026-305",
    category: "Packaging Materials",
    amount: 6800,
    date: "2026-08-05",
    paidTo: "Mahalaxmi Polybags & Corrugated Boxes",
    paymentMethod: "Cash",
    notes: "Stretch wrap rolls, barcode labels, and retail grocery carry bags",
    approvedBy: "Manager"
  },
  {
    id: "EXP-2026-306",
    category: "Handling & Labor",
    amount: 12000,
    date: "2026-08-06",
    paidTo: "Bhiwandi Mathadi Mathadi Labor Union",
    paymentMethod: "Bank Transfer",
    notes: "Heavy pallet unloading and grain stacking charges",
    approvedBy: "Manager"
  }
];

export const initialReturnsAndDamages = [
  {
    id: "RET-2026-01",
    type: "Customer → Shop Return",
    productId: "PROD-016",
    productName: "Kissan Fresh Tomato Ketchup (1kg Glass Bottle)",
    customerName: "Mrs. Sunita Deshpande (Monthly Ledger)",
    qty: 1,
    reason: "Cap seal broken during home delivery",
    date: "2026-08-06",
    financialImpact: -145,
    status: "Refunded / Replaced",
    actionTaken: "Item written off to Damage pool, replacement bottle dispatched."
  },
  {
    id: "RET-2026-02",
    type: "Shop → Supplier Claim",
    productId: "PROD-011",
    productName: "Parle-G Gold Glucose Biscuits (1kg Pack)",
    supplierName: "Parle Agro & Confectionery Wholesalers",
    qty: 22,
    reason: "Expired batch beyond 180-day shelf life",
    date: "2026-08-07",
    financialImpact: -1804,
    status: "Credit Note Requested",
    actionTaken: "Packed in Quarantine area for distributor pickup."
  },
  {
    id: "RET-2026-03",
    type: "Warehouse Handling Damage",
    productId: "PROD-017",
    productName: "Surf Excel Easy Wash Detergent Powder (5kg)",
    warehouseName: "Bhiwandi Central Mega Hub (WH-1)",
    qty: 2,
    reason: "Forklift pallet puncture during unloading",
    date: "2026-08-04",
    financialImpact: -1040,
    status: "Written Off",
    actionTaken: "Punctured bags segregated, claimed in transit insurance."
  }
];
